// @flow

import React, { type Node } from 'react';
import { GlobalStyle } from './global-style';
import { EbanxLogo } from './ebanx-logo';
import { LostInSpaceScene } from './lost-in-space-scene';
import { Content, Footer, Main, Message, Title, Wrapper } from './layout';
import { useEventBusPublisher } from '@tectonics/public-event-bus';

type Props = {
  error: Error,
};

export function FatalErrorPage({ error }: Props): Node {
  useEventBusPublisher('fatalError:dispatch', error);

  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <Main>
          <LostInSpaceScene />
          <Content>
            <Title>Oops!</Title>
            <Message>Infelizmente não conseguimos encontrar os dados do seu pagamento.</Message>
          </Content>
        </Main>
        <Footer>
          Pagamento seguro via <EbanxLogo />
        </Footer>
      </Wrapper>
    </>
  );
}
